import { Box, useStyleConfig, useColorModeValue } from "@chakra-ui/react";
function Card(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  const cardBg = useColorModeValue("white", "gray.700");
  return (
    <Box
      __css={styles}
      bg={cardBg}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default Card;
